import { createComponent, EventName } from '@lit/react';
import { BlocksQuantityPicker } from 'blocks-nextjs/blocks-web-components/components/quantity-picker/quantity-picker';
import { BlocksQuantityPickerChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';

export const CatQuantityPicker = createComponent({
  react: React,
  tagName: 'cat-quantity-picker',
  elementClass: BlocksQuantityPicker,
  events: {
    onBlQuantityPickerChange: 'bl-quantity-picker-change' as EventName<BlocksQuantityPickerChangeEvent>
  }
});
